import client from "./client";

const getCustomers = () => client.get("/subsidiary/dashboard/fetch/customers");

export default { getCustomers };
